import React from 'react';
import { Typography } from '@telus-uds/components-web';
import { useLocalizedStringsContext } from '../context/LocalizedStringsContext';

const SuccessMessage = () => {
  const localizedStrings = useLocalizedStringsContext();
  const {
    USERS: {
      USER_AUTHENTICATION: {
        UPDATE_PASSWORD_SCHEMA:{
          SUCCESS_MESSAGE,
          NOTE
        }
      }
    }
  } = localizedStrings;
  return (
    <>
      <div
        id="email_sent"
        className="informational_message"
        style={{ marginTop: 15 }}
      >
        <span
          className="frg-icon icon-warning-inverted"
          style={{
            fontSize: 14,
            color: '#66cc00',
            marginRight: 5
          }}
        />
        <Typography>
          <b>{NOTE}</b>: {SUCCESS_MESSAGE}
        </Typography>
      </div>
    </>
  );
};

export default SuccessMessage;
